import { net_filemanage } from "@/api/http";
export const API_STFMFM02C30_SendMail = (...params) =>
net_filemanage.post("/api/STFMFM02C30/SendMail", ...params)